import {
  AlertContainer,
  AlertTitle,
  AlertDescription,
} from '@/components/ui/alert';
import {
  WarningCircleIcon,
  CheckCircleIcon,
  InfoIcon,
  WarningIcon,
} from '@phosphor-icons/react';

const typeToIcon = {
  info: InfoIcon,
  warning: WarningIcon,
  error: WarningCircleIcon,
  success: CheckCircleIcon,
};

export function Alert({
  title,
  description,
  type,
  icon,
}: {
  title: React.ReactNode;
  description?: React.ReactNode;
  type: 'info' | 'warning' | 'error' | 'success';
  icon?: React.ReactNode;
}) {
  const Icon = typeToIcon[type];

  return (
    <AlertContainer variant={type === 'error' ? 'destructive' : 'default'}>
      {icon ? icon : <Icon className="size-4" />}
      <AlertTitle>{title}</AlertTitle>
      <AlertDescription>{description}</AlertDescription>
    </AlertContainer>
  );
}
